import api from './api'
import { 
  LoginRequest, 
  TokenResponse, 
  User, 
  QRCodeResponse 
} from '@/types'

export const authService = {
  // Iniciar sesión
  async login(credentials: LoginRequest): Promise<TokenResponse> {
    const response = await api.post<TokenResponse>('/auth/login', credentials)
    return response.data
  },

  // Obtener información del usuario actual
  async getCurrentUser(): Promise<User> {
    const response = await api.get<User>('/auth/me')
    return response.data
  },

  // Configurar 2FA (obtener QR)
  async setup2FA(): Promise<QRCodeResponse> {
    const response = await api.post<QRCodeResponse>('/auth/setup-2fa')
    return response.data
  },

  // Habilitar 2FA
  async enable2FA(totp_code: string): Promise<{ status: string; mensaje: string }> {
    const response = await api.post('/auth/enable-2fa', { totp_code })
    return response.data
  },

  // Deshabilitar 2FA
  async disable2FA(): Promise<{ status: string; mensaje: string }> {
    const response = await api.post('/auth/disable-2fa')
    return response.data
  }
}